// extracted by css-extract-rspack-plugin
export default {"root":"fmDYli6HsU5uFpNO"};